<template>
  <div class="card row cardBemVindo">
    <div class="col-12">
      <h4>Criticidade de OS abertas</h4>
      <canvas id="myChart"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.unregister(ChartDataLabels); // Se necessário, remova o plugin antes de registrar
Chart.plugins.register(ChartDataLabels); // Registra o plugin manualmente

export default {
  data() {
    return {
      criticidadeData: [], // Armazena os dados de criticidade
    };
  },
  mounted() {
    // Chamada à store para buscar dados do backend
    this.$store.dispatch('dashboard/getAtendimentosCriticidade').then(response => {
      // Extrair os valores e categorias da resposta
      this.criticidadeData = response.data.os_criticidade; // Armazena os dados

      // Mapear criticidades (rótulos)
      const labels = this.criticidadeData.map(item => {
          switch (item.nr_seq_criticidade) {
            case 1:
              return 'IMEDIATA';
            case 2:
              return 'ALTA';
            case 3:
              return 'MÉDIA';
            case 4:
              return 'LEVE';
            case 5:
              return 'URGENTE';
            default:
              return 'PREVENTIVA';
          }
      });
      // Mapear os totais de OS (dados)
      const totalOs = this.criticidadeData.map(item => item.total_os);

      console.log(labels) 
      console.log(totalOs)
      // Criar o gráfico
      this.renderChart(labels, totalOs);
    });
  },
  
  methods: {
    getCriticidadeLabel(nr_seq_criticidade) {
      switch (nr_seq_criticidade) {
        case 1:
          return 'IMEDIATA';
        case 2:
          return 'EMERGENCIAL';
        case 3:
          return 'ALTA';
        case 4:
          return 'MÉDIA';
        case 5:
          return 'LEVE';
        default:
          return 'PREVENTIVA';
      }
    },

    renderChart(labels, data) {
      const ctx = document.getElementById('myChart').getContext('2d');
      
      if (ctx) {
        const chart = new Chart(ctx, {
          type: 'bar', // Tipo de gráfico
          data: {
            labels: labels, // Rótulos extraídos da resposta
            datasets: [
              {
                label: ['CRITICIDADES'],
                data: data, // Dados extraídos da resposta
                backgroundColor: [
                  '#f03035',
                  '#f38833',
                  '#fbc110',
                  '#00a65a',
                  '#00aff1',
                ],
                borderColor: [
                  '#f03035',
                  '#f38833',
                  '#fbc110',
                  '#00a65a',
                  '#00aff1',
                ],
                borderWidth: 1,
              },
            ],
          },
          options: {
                  responsive: true,
                  plugins: {
                    datalabels: {
                      anchor: 'center', // Mantém o valor no meio da barra
                      align: 'center', // Alinha o número ao centro
                      color: '#FFFFFF', // Define a cor do texto como branco
                      font: {
                        size: 18,
                        weight: 'bold',
                        family: 'Arial', // Escolha a fonte desejada
                      },
                      textStrokeColor: '#000', // Contorno preto (opcional)
                      textStrokeWidth: 2, // Espessura do contorno para destaque
                      formatter: function (value) {
                        return value; // Exibe o valor corretamente
                      },
                    },
                  },
                },
          animation: {
            duration: 1,
            onComplete: function({ chart }) {
              const ctx = chart.ctx;

              chart.data.forEach(function(dataset, i) {
                const meta = chart.getDatasetMeta(i);

                meta.data.forEach(function(bar, index) {
                  const data = dataset.data[index];

                  ctx.fillText(data, bar.x, bar.y - 5);
                });
              });
            }
          } 
      }); 
    
      }
    },
  },
};
</script>

<style scoped>
  .cardBemVindo {
    flex-direction: row;
    align-items: flex-end;
    margin-right: 10px;
  }

  canvas {
    height: 400px;
    /* Define a altura fixa para o gráfico */
    width: 100%;
    /* Ocupar toda a largura disponível */
  }

  .details {
    margin-top: 20px;
    /* Espaçamento entre o gráfico e os detalhes */
  }

  table {
    width: 100%;
    /* Ocupar toda a largura disponível */
    border-collapse: collapse;
    /* Colapsa as bordas da tabela */
  }

  th,
  td {
    border: 1px solid #ddd;
    /* Borda padrão para células */
    padding: 8px;
    /* Espaçamento interno nas células */
    text-align: left;
    /* Alinhamento à esquerda do texto */
  }

  th {
    background-color: #f2f2f2;
    /* Cor de fundo para cabeçalhos */
  }

  canvas {
    color: white !important;
  }
</style>
